import React from "react";
import "./Social.css";
import linkedin from "./../../images/icons/linkedin-circled-click.gif";
import facebook from "./../../images/icons/facebook-circled-shake.gif";
import github from "./../../images/icons/github.webp";
import gitlab from "./../../images/icons/gitlab.gif";
import twitter from "./../../images/icons/twitter.gif";
import skype from "./../../images/icons/skype.gif";
import telegram from "./../../images/icons/telegram.gif";

const Skills = () => {
  return (
    <>
      <div
        id="Skills"
        className="d-flex align-items-center justify-content-center "
      >
        <div className="">
          <div className="link-container mx-3">
            <a
              className="link-one"
              href="https://github.com/ShahriarAhmod"
              target="blank"
            >
              <h2 className="first_button">
                <img className="me-1" src={github} width="25px" alt="" />
                Github
              </h2>
            </a>
          </div>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-two"
            href="https://www.linkedin.com/in/shahriar-ahmod/"
            target="blank"
          >
            <h2 className="second_button">
              <img className="me-1" src={linkedin} width="25px" alt="" />
              Linkedin
            </h2>
          </a>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-one"
            href="https://www.facebook.com/SnakeEyes969/"
            target="blank"
          >
            <h2 className="third_button">
              <img className="me-1" src={facebook} width="25px" alt="" />
              Facebook
            </h2>
          </a>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-one"
            href="https://twitter.com/shahriyar_ahmod"
            target="blank"
          >
            <h2 className="third_button">
              <img className="me-1" src={twitter} width="25px" alt="" />
              Twitter
            </h2>
          </a>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-one"
            href="https://t.me/snekeyes"
            target="blank"
          >
            <h2 className="fourth_button">
              <img className="me-1" src={telegram} width="25px" alt="" />
              Telegram
            </h2>
          </a>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-two"
            href="https://join.skype.com/invite/u1UZ4ZZJjR2H"
            target="blank"
          >
            <h2 className="fifth_button">
              <img className="me-1" src={skype} width="25px" alt="" />
              Skype
            </h2>
          </a>
        </div>
        <div className=" link-container mx-3">
          <a
            className="link-two"
            href="https://gitlab.com/ShahriarAhmod"
            target="blank"
          >
            <h2 className="sixth_button">
              <img className="me-1" src={gitlab} width="25px" alt="" />
              Gitlab
            </h2>
          </a>
        </div>
      </div>
    </>
  );
};

export default Skills;
